import {Component, Inject, Input, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableFooterDataModel} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import {ARService} from '../../ar.service';
import {CurrencyPipe} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {MessagingService} from '../../../../services/messaging.service';
import {Router} from '@angular/router';
import {DataARPaymentListModel} from '../../models/data-ar-payment-list.model';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';

@Component({
  selector: 'app-ar-ledger-payment-distributions',
  templateUrl: './ar-ledger-payment-distributions.component.html',
  styleUrls: ['./ar-ledger-payment-distributions.component.scss']
})
export class ArLedgerPaymentDistributionsComponent implements OnInit {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  @ViewChildren(TdoTableV2Component) tdoTables;
  @Input() LedgerID: string;

  searchPredicate: (data: any, filter: string) => boolean;
  footerData: TdoTableFooterDataModel[] = [];

  isLoading: boolean = true;
  paymentDistributions: DataARPaymentListModel[];

  enumLedgerItemTypeCredit: string = '00000078-1000-0000-0000-000000000001';
  enumLedgerItemTypeDebit: string = '00000078-1000-0000-0000-000000000002';
  enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';
  //enumLedgerItemStatusPaid: string = '00000083-1000-0000-0000-000000000002';
  //enumLedgerItemStatusVoid: string = '00000083-1000-0000-0000-000000000003';

  enumPaymentTypeCheck: string = '00000080-1000-0000-0000-000000000001';
  enumPaymentTypeCash: string = '00000080-1000-0000-0000-000000000002';
  enumPaymentTypeElectronic: string = '00000080-1000-0000-0000-000000000003';
  enumPaymentTypeElectronicOffline: string = '00000080-1000-0000-0000-000000000004';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private currencyPipe: CurrencyPipe,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ArLedgerPaymentDistributionsComponent>,
  ) { }

  ngOnInit(): void {

    if (this.data.LedgerID) {
      this.LedgerID = this.data.LedgerID;
    }

    this.isLoading = true;

    const promises = [
      this.getPaymentDistributionsList()
    ];

    Promise.all(promises).then((results: any[]) => {
      this.paymentDistributions = results[0];
      this.isLoading = false;
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    });
  }

  getPaymentDistributionsList() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getPaymentDistributionsForLedgerItem(this.LedgerID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onRowSelected($event: TdoTableSelectionEvent) {

  }

  getPaymentTypeName(row: DataARPaymentListModel) {
    if (row.enumARPayementTypeID === this.enumPaymentTypeElectronic) {
      return 'Electronic';
    }
    else if (row.enumARPayementTypeID === this.enumPaymentTypeElectronicOffline) {
      return 'Electronic Offline';
    }
    else if (row.enumARPayementTypeID === this.enumPaymentTypeCheck) {
      return 'Check';
    }
    else if (row.enumARPayementTypeID === this.enumPaymentTypeCash) {
      return 'Cash';
    }
  }

  closeRef() {
    this.dialogRef.close();
  }
}
